/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseLifecycleState } from './courseLifecycleState';

export type CourseState = CourseLifecycleState | null;
